import JSZip from 'jszip';
import {saveAs} from 'file-saver';
import {eachLimit} from 'async';
import _ from 'lodash';
import {RouteService} from "../../../services/routeService";
import {NotificationService} from "../../../services/notificationService";
import {GeneralService} from "../../../services/generalService";
import {DICTIONARY} from "../../../dictionary";
import {Component, OnInit} from "@angular/core";
import {ArchiveService} from "../../../services/archiveService";


@Component({
	selector: 'archive-search-component',
	templateUrl: './archive-search.component.html',
})
export class ArchiveSearchComponent implements OnInit {

	constructor(private rs:RouteService,
				private ns:NotificationService,
				public gs:GeneralService,
				public archiveService:ArchiveService){
    }

    dic = DICTIONARY;

	abortLoadingFlag = false;

    getEmailsInProcess = false;

	hasSearched = false;

	searchArchiveEmailTxt;
	selectedAll;
	selectedEmails = [];

	// CC: taken from inbound-email-rules.component.html -> list/graph view toggle
	viewTypes = {
		list: 'list',
		table: 'table'
	};
	viewMode = this.viewTypes.list;

	changeViewType = (viewMode) => {
		this.viewMode = viewMode;
		this.archiveService.setCurrentEmail(null);
	};

	casesPeriods = [
		this.dic.CONSTANTS.trendsPeriod.lastDay,
		this.dic.CONSTANTS.trendsPeriod.last3Days,
		this.dic.CONSTANTS.trendsPeriod.lastWeek,
		this.dic.CONSTANTS.trendsPeriod.lastMonth,
		this.dic.CONSTANTS.trendsPeriod.range,
		this.dic.CONSTANTS.trendsPeriod.all
	];

    previewEmailInProcess;
	archiveConfig;
	defaultRange = {start: new Date(Date.now() - (1000 * 60 * 60 * 24)), end: new Date()}; // (past one day);
	queryTypes = {
		normal: 'normal',
		messageIdOnly: 'messageIdOnly'
	};

	compliances:any = [{name: "GDPR"}, {name: "FERPA"}, {name: "HIPAA"}, {name: "PCI"},
		{name: "CCPA"}, {name: "POPI"}, {name: "LGPD"}, {name: "PDPO"}, {name: "GLBA"}];

	emailQueryDisplay;
	queryType;
	resultsPeriod;
	range;
	showQueryModal;
	emailQuery;

	savedCases = [];
	selectedCase = null;
	saveAsCaseInput = null;
	caseActionInProcess = false;

	ngOnInit() {
        this.hasSearched = false;
        this.archiveService.currentEmailsList = [];
        this.archiveService.currentFilteredEmailsList = [];
        this.archiveService.setCurrentEmail(null);

        this.initEmailQuery();

		this.rs.getArchiveConfiguration().then(response => {
			this.archiveConfig = response.archive;
		}, (err) => {
		});

		// CC: taken from archive-cases.component.ts -> runCase (autorun a saved case's query when arriving from the Cases page)
		this.loadSavedCases(window.history.state.caseName);
    };

	ngOnDestroy(): void {
		this.abortLoadingFlag = true;
	}

	initEmailQuery = () => {
		this.queryType = this.queryTypes.normal;
		this.resultsPeriod = this.dic.CONSTANTS.trendsPeriod.lastDay;
		this.range = {start: new Date(Date.now() - (1000 * 60 * 60 * 24)), end: new Date()}; // (past one day)

		this.emailQuery = {
			subject: '',
			message_id: '',
			conditionsOperator: this.dic.CONSTANTS.archiveCaseConditionsOperator.and.value,
		};

		this.emailQueryDisplay = [
			{
				title: this.gs.toCapitalize(this.resultsPeriod.display),
				tooltip: this.gs.toCapitalize(this.resultsPeriod.display)
			}
		];
		this.compliances.forEach((comp) => {
			comp.selected = false;
		});
	}

	// CC: taken from archive-search.component.ts -> openEditCasePopup (normalize a saved case's query into the search filters)
	loadQueryFromCase = (caseObj) => {
		this.emailQuery = _.cloneDeep(caseObj.query);

		this.range = {
			start: this.emailQuery.range?.start ? new Date(this.emailQuery.range.start) : this.defaultRange.start,
			end: this.emailQuery.range?.end ? new Date(this.emailQuery.range.end) : this.defaultRange.end
		};
		this.emailQuery.range = this.range;
		this.resultsPeriod = this.dic.CONSTANTS.trendsPeriod[this.emailQuery.period] || this.dic.CONSTANTS.trendsPeriod.lastDay;

		this.compliances.forEach((comp) => {
			comp.selected = !!this.emailQuery.compliance?.includes(comp.name);
		});


		this.queryType = this.emailQuery.message_id ? this.queryTypes.messageIdOnly : this.queryTypes.normal;

		this.calculateQueryDisplay();
	}

	changePeriod = (period) => {
		this.resultsPeriod = period;
	};

	abortLoadingEmails = () => {
		this.abortLoadingFlag = true;
		this.getEmailsInProcess = false;
	}

	resetQuery = () => {
		this.initEmailQuery();
		this.calculateQueryDisplay();
	};

    applyQuery = () => {
        if (this.getEmailsInProcess) {
            return;
        }

        this.getEmailsInProcess = true;
		this.abortLoadingFlag = false;

		const params = this.getQueryForEmail();

		this.calculateQueryDisplay();

		this.showQueryModal = false;
		this.hasSearched = true;

		this.archiveService.currentEmailsList = [];
		this.archiveService.currentFilteredEmailsList = [];
		this.selectedEmails = [];

		this.rs.searchArchiveDirect(params).then((response) => {
			this.archiveService.setCurrentEmail(null);

			const emails = this.archiveService.currentEmailsList.concat((response.emails || []));

			this.archiveService.currentEmailsList = _.orderBy(emails, ['_source.created'], ['desc']);
			this.searchEmailInResults(this.searchArchiveEmailTxt);

			if (response.scrollId) {
				this.applyQueryBatch(params, response.scrollId);
			}
			else {
				this.getEmailsInProcess = false;
			}
		},(err)=>{
			this.getEmailsInProcess = false;
		});
    }

	applyQueryBatch = (params, scrollId) => {
		if (this.abortLoadingFlag) {
			return;
		}
		if (scrollId) {
			params.scrollId = scrollId;
		}

		this.rs.searchArchiveDirect(params).then((response) => {

			if (response.emails?.length) {
				const emails = this.archiveService.currentEmailsList.concat(response.emails || []);

				this.archiveService.currentEmailsList = _.orderBy(emails, ['_source.created'], ['desc']);
				this.searchEmailInResults(this.searchArchiveEmailTxt);
			}

			if (response.scrollId) {
				this.applyQueryBatch(params, response.scrollId);
			}
			else {
				this.getEmailsInProcess = false;
			}
		},(err)=>{
			this.getEmailsInProcess = false;
		});
	}

	getQueryForEmail = () => {
		if (this.queryType ===  this.queryTypes.messageIdOnly) {
			return {
				message_id: this.emailQuery.message_id || null
			}
		}
		else {
			const query:any = {
				period: this.resultsPeriod.value,
			};

			if (this.emailQuery.conditionsOperator === this.dic.CONSTANTS.archiveCaseConditionsOperator.or.value) {
				query.conditionsOperator = this.emailQuery.conditionsOperator;
			}

			if (query.period === this.dic.CONSTANTS.trendsPeriod.range.value) {
				query.range = this.range;
			}

			if (this.emailQuery.subject) {
				query.subject = this.emailQuery.subject;
				if (this.emailQuery.subjectNegate) {
					query.subjectNegate = this.emailQuery.subjectNegate;
				}
			}

			if (this.emailQuery.text) {
				query.text = this.emailQuery.text;
				if (this.emailQuery.textNegate) {
					query.textNegate = this.emailQuery.textNegate;
				}
			}
			if (this.emailQuery.from) {
				query.from = this.emailQuery.from;
				if (this.emailQuery.fromNegate) {
					query.fromNegate = this.emailQuery.fromNegate;
				}
			}
			if (this.emailQuery.rcptTo) {
				query.rcptTo = this.emailQuery.rcptTo;
				if (this.emailQuery.rcptToNegate) {
					query.rcptToNegate = this.emailQuery.rcptToNegate;
				}
			}

			if (this.emailQuery.hasAttachments) {
				query.hasAttachments = this.emailQuery.hasAttachments;
				if (this.emailQuery.attachmentName) {
					query.attachmentName = this.emailQuery.attachmentName;
				}
			}

			if (this.emailQuery.sizeMin) {
				query.sizeMin = this.emailQuery.sizeMin;
			}
			if (this.emailQuery.sizeMax) {
				query.sizeMax = this.emailQuery.sizeMax;
			}

			const compliances = [];
			this.compliances.forEach((comp) => {
				if (comp.selected) {
					compliances.push(comp.name);
				}
			});
			this.emailQuery.compliance = compliances;
			if (compliances.length) {
				query.compliance = compliances;
			}

			return query;
		}
	}

	// CC: builds the chip list shown inside the query box
	calculateQueryDisplay = () => {
		if (this.queryType ===  this.queryTypes.messageIdOnly) {
			this.emailQueryDisplay = [
				{
					title: 'message ID',
					tooltip: this.emailQuery.message_id
				}
			];
		}
		else {
			this.emailQueryDisplay = [];

			// CC: period chip — expand date range when applicable
			let periodTooltip = this.gs.toCapitalize(this.resultsPeriod.display);
			if (this.gs.equals(this.resultsPeriod, this.dic.CONSTANTS.trendsPeriod.range)) {
				periodTooltip = 'From ' + this.range.start + ' until ' + this.range.end;
			}
			this.emailQueryDisplay.push(
				{
					title: this.gs.toCapitalize(this.resultsPeriod.display),
					tooltip: periodTooltip
				}
			);

			_.mapValues(this.emailQuery, (value, queryKey) => {
				if (value) {
					switch (queryKey) {
						case 'message_id':
							break;

						case 'hasAttachments':
							this.emailQueryDisplay.push({title: 'Has Attachments', tooltip: this.emailQuery.attachmentName ? 'true (' + this.emailQuery.attachmentName + ')' : 'true'});
							break;

						case 'attachmentName':
							break;

						case 'rcptTo':
							this.emailQueryDisplay.push({title: 'Recipients', tooltip: this.emailQuery.rcptToNegate ? ('Not: ' + value) : value});
							break;

						case 'subject':
							this.emailQueryDisplay.push({title: 'Subject', tooltip: this.emailQuery.subjectNegate ? ('Not: ' + value) : value});
							break;

						case 'text':
							this.emailQueryDisplay.push({title: 'Text', tooltip: this.emailQuery.textNegate ? ('Not: ' + value) : value});
							break;

						case 'from':
							this.emailQueryDisplay.push({title: 'From', tooltip: this.emailQuery.fromNegate ? ('Not: ' + value) : value});
							break;

						case 'compliance':
							if (value?.length) {
								this.emailQueryDisplay.push({title: 'Compliance', tooltip: value.join(', ')});
							}
							break;

						case 'sizeMin':
							this.emailQueryDisplay.push({title: 'Min Size', tooltip: value + ' MB'});
							break;

						case 'sizeMax':
							this.emailQueryDisplay.push({title: 'Max Size', tooltip: value + ' MB'});
							break;

						case 'conditionsOperator':
							if (value === this.dic.CONSTANTS.archiveCaseConditionsOperator.or.value) {
								this.emailQueryDisplay.push({title: 'Match ANY (OR)', tooltip: 'Conditions logic: Match ANY (OR)'});
							}
							break;

						case 'subjectNegate':
						case 'textNegate':
						case 'fromNegate':
						case 'rcptToNegate':
						case 'period':
						case 'range':
						case 'queryType':
							// CC: already represented by another chip or not a display field
							break;

						default:
							this.emailQueryDisplay.push({title: queryKey, tooltip: value});

					}
				}
			});
		}
	}

	// CC: taken from archive-search.component.ts (original) / reused by both the list view and the table view's own searchFunction
	clearSearchEmail() {
		this.archiveService.currentEmailsList.forEach(email => {
			email.hide = false;
		});
		this.searchArchiveEmailTxt = null;
		this.archiveService.currentFilteredEmailsList = _.reject(this.archiveService.currentEmailsList, 'hide');
		this.checkSelectAllEmails();
	};

	searchEmailInResults(searchTerm) {
		if (!searchTerm) {
			this.clearSearchEmail();
			return;
		}

		searchTerm = searchTerm.toLowerCase();

		this.archiveService.currentEmailsList.forEach(email => {
			const isFound = searchTextExecute(email, searchTerm);
			email.hide = !isFound;
		});
		this.archiveService.currentFilteredEmailsList = _.reject(this.archiveService.currentEmailsList, 'hide');
		this.checkSelectAllEmails();
	};

	toggleAllEmails = () => {
		this.archiveService.currentFilteredEmailsList.forEach(email => {
			email.selected = this.selectedAll;
		});
		this.filterSelectedEmails();
	};

	filterSelectedEmails = () => {
		this.selectedEmails = _.filter(this.archiveService.currentFilteredEmailsList, 'selected');
	};

	checkSelectAllEmails = () => {
		this.filterSelectedEmails();
		this.selectedAll = this.archiveService.currentFilteredEmailsList.length && (this.selectedEmails.length === this.archiveService.currentFilteredEmailsList.length);
	};

    getArchiveEmailInfo = (email) => {
        if (this.archiveService.currentMessage) {
            this.archiveService.currentMessage.show = false;
        }

        email.show = true;
        this.archiveService.setCurrentEmail(email);
        if (email.content) {
			this.archiveService.updateEmailFrame();
            return;
        }
        this.previewEmailInProcess = true;
        this.rs.getArchiveEmailInfo(encodeURIComponent(email._id)).then((response) => {
            email.content = response;

            if (email.content) {
                // calc Bcc according to rcptTo
                email.content.parsedContent.bcc = {value: []};
                email._source.rcptTo.forEach((recipientEmail) => {
                    // if not in To/Cc then it's Bcc
                    if (!((email.content.parsedContent.to?.text?.toLowerCase().indexOf(recipientEmail) > -1) ||
                        (email.content.parsedContent.cc?.text?.toLowerCase().indexOf(recipientEmail) > -1))) {

                        email.content.parsedContent.bcc.value.push({address: recipientEmail});
                    }
                });
            }
			this.archiveService.setCurrentEmail(email);
			this.archiveService.updateEmailFrame();

			this.previewEmailInProcess = false;
        }, (err)=>{
            this.previewEmailInProcess = false;
        });
    }

	// CC: taken from archive-cases.component.ts -> exportToCsv
    exportResultsToCsv = (sortBy?) => {
        if (!this.archiveService.currentEmailsList.length) {
            this.ns.showWarnMessage(this.dic.ERRORS.noDataToExportCsv);
            return;
        }

        let csvString = "Subject,Date,From,Recipients,Attachments,Message ID\n";

		let sortedList = _.filter(this.archiveService.currentEmailsList, email => !email.hide);
		if (sortBy) {
			sortedList = this.gs.sortTable(sortedList, sortBy);
		}

		sortedList.forEach((email) => {
            csvString += `${email._source.subject},"${email._source.created}","${email._source.from}","${email._source.rcptTo && email._source.rcptTo.join(', ')}","${email._source.attachments && email._source.attachments.join(', ')}","${email._source.messageId}"\n`;
        });

        this.gs.exportCsv(csvString, `archive_search_emails_list.csv`);
    };

	showEmailActions = (email) => {
		const actions = ['Download EML', 'Restore'];
		if (this.archiveConfig?.allow_delete) {
			actions.push('Delete');
		}
		return actions;
	}

    selectAction = (emailObj, action) => {
        switch (action) {
            case 'Delete':
                this.archiveService.deleteEmailFromArchive(emailObj, () => {});
                break;

			case 'Download EML':
				this.downloadMultipleEmls([emailObj]);
				break;

			case 'Restore':
				this.restoreMultipleEmails([emailObj]);
				break;
        }
    };

	showBulkActions = () => {
		const actions = ['Download EMLs', 'Restore'];
		if (this.archiveConfig?.allow_delete) {
			actions.push('Delete');
		}
		return actions;
	}

	selectMultipleEmailsAction = (emails, action) => {
		switch (action) {
			case 'Delete':
				this.deleteMultipleEmails(emails);
				break;

			case 'Download EMLs':
				this.downloadMultipleEmls(emails);
				break;

			case 'Restore':
				this.restoreMultipleEmails(emails);
				break;
		}
	};

	downloadMultipleEmls = (emails) => {
		if (!emails.length) {
			return;
		}

		if (emails.length === 1) {
			this.rs.getArchiveEmailInfo(encodeURIComponent(emails[0]._id)).then((response) => {
				const attachment = {
					content: response.rawMail,
					name: `${response.parsedContent.subject}.eml`,
					contentType: 'message/rfc822'
				};
				this.gs.downloadData(attachment.content, attachment.name, attachment.contentType);
				this.ns.showInfoMessage(`Downloaded EML`);
			});
			return;
		}

		const notIdx = this.ns.showInfoMessage(`Downloading ${emails.length} EMLs...`, {timeout: 0});

		const zip = new JSZip();

		let filenames = {};
		let count = 0;
		eachLimit(emails, 10, (emailObj, callback) => {
			this.rs.getArchiveEmailInfo(encodeURIComponent(emailObj._id)).then((response) => {
				let emlFileName = removeNonAlphaNumeric(response.parsedContent.subject);
				if (!emlFileName) {
					emlFileName = `(No Subject)`;
				}
				if (filenames.hasOwnProperty(emlFileName)) {
					filenames[emlFileName]++;
					emlFileName = `${emlFileName}(${filenames[emlFileName]})`;
				}
				else {
					filenames[emlFileName] = 0;
				}

				zip.file(`${emlFileName}.eml`, response.rawMail);
				callback();

				count++;
				this.ns.overwriteMessage(notIdx, `${count} / ${emails.length} EML files processed. Please wait for the operation to complete and do not navigate away from this page.`);
			}, () => {
				this.ns.showErrorMessage(`Failed to download EML ${emailObj._source.subject}`);
				callback();
			});
		}, (err) => {
			filenames = null;
			zip.generateAsync({ type: 'blob' }).then((content) => {
				// Save the zip file
				saveAs(content, `archive_search_emails.zip`);
				this.ns.overwriteMessage(notIdx, `Download completed`);
			});
		})
	}

    deleteMultipleEmails = (emails) => {
        if (!emails.length) {
            return;
        }
        else if (emails.length === 1) {
            this.archiveService.deleteEmailFromArchive(emails[0], () => {
				this.ns.showInfoMessage('Email deleted successfully');
			});
            return;
        }

        this.gs.showPopup({
            title: 'Delete Emails',
            subTitle: `Are you sure you want to delete ${emails.length} emails from archive?`,
            type: this.dic.CONSTANTS.popupWarning,
            doneBtnText: 'Delete',
            doneCb: () => {
                emails.forEach((emailObj) => {
                    this.archiveService.deleteEmailFromArchive(emailObj, () => {
                        this.ns.showInfoMessage('Email deleted successfully');
                    })
                });
            }
        });
    }

	restoreMultipleEmails = (emails) => {
		if (!emails.length) {
			return;
		}

		this.gs.showPopup({
			title: emails.length > 1 ? 'Restore Emails' : 'Restore Email',
			subTitle: `Are you sure you want to restore ${emails.length > 1 ? emails.length + ' emails' : 'this email'} from archive?`,
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: 'Restore',
			doneCb: () => {
				const total = emails.length;
				const notIdx = this.ns.showInfoMessage(`Restoring 0 / ${total} emails...`, {timeout: 0});
				let restored = 0;
				let failed = 0;

				eachLimit(emails, 5, (emailObj, callback) => {
					const mailboxes = [...new Set(emailObj._source.rcptTo)];
					this.rs.restoreEmailFromArchive(emailObj._id, {mailboxes}).then(() => {
						restored++;
						this.ns.overwriteMessage(notIdx, `Restoring ${restored} / ${total} emails...`);
						callback();
					}, () => {
						failed++;
						callback();
					});
				}, () => {
					// CC: final summary message
					const failedText = failed ? ` (${failed} failed)` : '';
					this.ns.overwriteMessage(notIdx, `Restored ${restored} / ${total} emails${failedText}`);
				});
			}
		});
	}

	// CC: taken from inbound-quarantined.component.ts -> selectQueryTemplate (applied to archive cases)
	selectQueryTemplate = (caseObj) => {
		this.loadQueryFromCase(caseObj);
		this.selectedCase = caseObj;
	}

	// CC: taken from inbound-quarantined.component.ts -> getCurrentQueryModelAsTemplate (serializes current query into archive-case format)
	getCurrentQueryModelAsTemplate = () => {
		if (this.queryType === this.queryTypes.messageIdOnly) {
			return {message_id: this.emailQuery.message_id};
		}

		const query: any = {
			period: this.resultsPeriod.value,
			range: this.range,
			conditionsOperator: this.emailQuery.conditionsOperator,
			subject: this.emailQuery.subject,
			subjectNegate: this.emailQuery.subjectNegate,
			text: this.emailQuery.text,
			textNegate: this.emailQuery.textNegate,
			from: this.emailQuery.from,
			fromNegate: this.emailQuery.fromNegate,
			rcptTo: this.emailQuery.rcptTo,
			rcptToNegate: this.emailQuery.rcptToNegate,
			hasAttachments: this.emailQuery.hasAttachments,
			attachmentName: this.emailQuery.attachmentName,
			sizeMin: this.emailQuery.sizeMin || null,
			sizeMax: this.emailQuery.sizeMax || null,
			compliance: this.compliances.filter(comp => comp.selected).map(comp => comp.name)
		};

		return query;
	}

	// CC: taken from inbound-quarantined.component.ts -> getTableQueryTemplates (loads archive cases into the query dropdown)
	loadSavedCases = (autoApplyCaseName?) => {
		this.rs.getArchiveCases().then(response => {
			this.savedCases = response || [];
			if (autoApplyCaseName) {
				const caseObj = _.find(this.savedCases, savedCase => savedCase.name === autoApplyCaseName);
				if (!caseObj) {
					this.ns.showWarnMessage("Case not found");
					return;
				}
				this.selectQueryTemplate(caseObj);
				this.applyQuery();
			}
		}, (err) => {});
	}

	// CC: taken from inbound-quarantined.component.ts -> saveTableQueryTemplate (create or update an archive case)
	saveAsCase = () => {
		const name = this.saveAsCaseInput?.name?.trim();
		if (!name) {
			this.ns.showWarnMessage('Case name cannot be empty');
			return;
		}
		if (this.caseActionInProcess) {
			return;
		}

		this.caseActionInProcess = true;
		const existingCase = _.find(this.savedCases, savedCase => savedCase.name === name);

		if (existingCase) {
			const updatedQuery = this.getCurrentQueryModelAsTemplate();
			this.rs.updateArchiveCase(existingCase._id, {query: updatedQuery}).then(() => {
				existingCase.query = updatedQuery;
				this.selectedCase = existingCase;
				this.saveAsCaseInput = null;
				this.caseActionInProcess = false;
				this.ns.showInfoMessage('Case was updated successfully');
			}, (err) => {
				this.caseActionInProcess = false;
			});
		}
		else {
			this.rs.addArchiveCase({name, query: this.getCurrentQueryModelAsTemplate()}).then(response => {
				this.savedCases.push(response.case);
				this.selectedCase = response.case;
				this.saveAsCaseInput = null;
				this.caseActionInProcess = false;
				this.ns.showInfoMessage('Case was created successfully');
			}, (err) => {
				if (err?.data?.message && !err?.data?.display_bar) {
					this.ns.showErrorMessage(err.data.message);
				}
				this.caseActionInProcess = false;
			});
		}
	}

	// CC: taken from inbound-quarantined.component.ts -> deleteQueryTemplate (delete an archive case from dropdown)
	deleteCase = (caseObj) => {
		this.gs.showPopup({
			title: 'Delete Case',
			subTitle: `Are you sure you want to delete "${caseObj.name}"?`,
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Delete',
			doneCb: () => {
				this.rs.deleteArchiveCase(caseObj._id.toString()).then(() => {
					_.remove(this.savedCases, savedCase => savedCase._id.toString() === caseObj._id.toString());
					if (this.selectedCase?._id.toString() === caseObj._id.toString()) {
						this.selectedCase = null;
					}
					this.ns.showInfoMessage('Case was successfully deleted');
				});
			}
		});
	}

}

function searchTextExecute(email, searchTerm) {
    searchTerm = searchTerm.toLowerCase();
    if (email._source.rcptTo) {
        for (let idx = 0; idx < email._source.rcptTo.length; idx++) {
            if (email._source.rcptTo[idx].indexOf(searchTerm) > -1) {
                return true;
            }
        }
    }
    return ((email._source.subject && email._source.subject.toLowerCase().indexOf(searchTerm) > -1) ||
		(email._source.from && email._source.from.toLowerCase().indexOf(searchTerm) > -1));
}

function removeNonAlphaNumeric(str) {
	return str?.replace(/[^a-z0-9\s_@]/gi, '');
}
